import {
  ApiService,
  ConfigModel,
  LoggerFactory,
  Persistence,
  SessionPersistence,
  SessionStoragePersistence
} from '@ibe/services';
import { bookingService } from '../Hooks/Contexts';

export class SessionData {
  bookingId: string;
}

const logger = LoggerFactory.get('initBookingService');

export async function initBookingService(
  config: ConfigModel,
  api: ApiService,
  useSessionStorage?: boolean,
  keyPrefix?: string,
  packageId?: string,
  throwError?: boolean
): Promise<void> {
  logger.log('initBookingService...');

  let session: Persistence<SessionData>;
  let cartSession: Persistence<string>;

  if (useSessionStorage) {
    session = new SessionStoragePersistence<SessionData>(SessionData);
    cartSession = new SessionStoragePersistence<string>();
  } else {
    session = new SessionPersistence<SessionData>(SessionData);
    cartSession = new SessionPersistence<string>();
  }

  if (keyPrefix) {
    session.useKey(keyPrefix + config.sessionKeyCart);
    cartSession.useKey(keyPrefix + config.sessionKeyPackageCart);
  } else {
    session.useKey(config.sessionKeyCart);
    cartSession.useKey(config.sessionKeyPackageCart);
  }

  const persisted = session.get();
  try {
    bookingService.setApi(api);
    await bookingService.init(persisted.bookingId, false, packageId, cartSession.get());
    if (bookingService.booking) {
      session.set({
        bookingId: bookingService.booking.id
      });
      if (!!bookingService.packageCart) {
        cartSession.set(bookingService.packageCart.id);
      }
    } else {
      session.clear();
    }
  } catch (e) {
    logger.error(e);
    session.clear();
    if (throwError) {
      throw e;
    }
  }
}
